//@flow
import type {
  PopupPositionType,
  PopupButtonActionType,
  PopupButtonEntityType,
  PopupTriggerType,
  PopupBannerTriggerValueCriteriaType,
} from '../../../../../../../entities';
export const POPUP_BANNER_FIELDS = {
  IMAGE: 'image',
  TITLE: 'title',
  SUBTITLE: 'subtitle',
  BACKGROUND_COLOR: 'backgroundColor',
  TEXT_COLOR: 'textColor',
  CONTENT_POSITION: 'contentPosition',
  BUTTON_TEXT: 'buttonText',
  BUTTON_ACTION: 'buttonAction',
  BUTTON_URL_TYPE: 'buttonUrlType',
  BUTTON_URL_IDENTIFIER: 'buttonUrlIdentifier',
  BUTTON_BACKGROUND_COLOR: 'buttonBackgroundColor',
  BUTTON_TEXT_COLOR: 'buttonTextColor',
  TRIGGER_VALUE: 'triggerValue',
  TRIGGER_TYPE: 'triggerType',
  TRIGGER_VALUE_CRITERIA_TYPE: 'triggerValueCriteriaType',
};

export type PopupBannerForm = {
  image?: string,
  title?: string,
  subtitle?: string,
  backgroundColor: string,
  textColor?: string,
  contentPosition: PopupPositionType,
  buttonText: string,
  buttonAction: PopupButtonActionType,
  buttonUrlType?: PopupButtonEntityType,
  buttonUrlIdentifier?: string,
  buttonBackgroundColor: string,
  buttonTextColor: string,
  triggerType: PopupTriggerType,
  triggerValue?: number,
  triggerValueCriteriaType: PopupBannerTriggerValueCriteriaType,
};

export const POPUP_BANNER_EDITOR_ID = 'POPUP_BANNER_EDITOR_ID';
export const POPUP_BANNER_CONTENT_ID = 'POPUP_BANNER_CONTENT_ID';
export const POPUP_BANNER_CLOSE_ID = 'POPUP_BANNER_CLOSE';

export const POPUP_BANNER_LAYOUTS = {
  BELOW: 'BELOW',
  CENTER: 'CENTER',
};
export const POPUP_BUTTON_ACTION = {
  CLOSE: 'CLOSE',
  REDIRECT: 'REDIRECT',
};

export const POPUP_TRIGGER_TYPE = {
  TIME_PASSED: 'TIME_PASSED',
  SCROLL: 'SCROLL',
  PAGES_VISITED: 'PAGES_VISITED',
  IMMEDIATE: 'IMMEDIATE',
};

export const POPUP_TRIGGER_VALUE_CRITERIA_TYPE = {
  FIXED: 'FIXED',
  PERCENTAGE: 'PERCENTAGE',
};

type GenericStorefrontPage = {
  path: string,
  label: string,
};

export const GENERIC_STOREFRONT_PAGES: GenericStorefrontPage[] = [
  {
    path: '/products',
    label: 'Todos los productos',
  },
  {
    path: '/products',
    label: 'Todas las categorías',
  },
  {
    path: '/information/about-us',
    label: 'Sobre nosotros',
  },
  {
    path: '/information/complaints',
    label: 'Libro de reclamaciones',
  },
  {
    path: '/information/faq',
    label: 'Preguntas frecuentes',
  },
  {
    path: '/information/refunds',
    label: 'Devoluciones',
  },
  {
    path: '/information/shipping',
    label: 'Envíos y pagos',
  },
  {
    path: '/information/terms',
    label: 'Términos y condiciones',
  },
  {
    path: '/reviews',
    label: 'Reseñas',
  },
];

export const POPUP_LAYOUT_SIZE = {
  [POPUP_BANNER_LAYOUTS.BELOW]: {
    width: 750,
    height: 1060,
    aspectRatio: 1.28,
  },
  [POPUP_BANNER_LAYOUTS.CENTER]: {
    width: 825,
    height: 938,
    aspectRatio: 0.88,
  },
};
